'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Portal } from '@common/components';
import { SvgDelete, SvgLogo } from '@common/icon';
import { cn, createOAuthUrl } from '@core/utils';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { NarrowContentContainer } from '@/app/_components/NarrowContentContainer';
import { LoadingPageTemplate } from '@/components/client';
import { BREAKPOINTS, ENV, ROUTES, STORAGE_KEY, SUB_DOMAIN } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useLoginUrlData } from '@/hooks/useLoginUrlData';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useAppBack } from '@/modules/wello-app/_hooks/useAppBack';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { useStoreMemberCode } from '../_hooks/useStoreMemberCode';
import { ResignModal } from './ResignModal';
import { SocialLoginSection } from './SocialLoginSection';
const LoginTemplate = () => {
  const $ = _c(18);
  useAppBack();
  const searchParams = useSearchParams();
  const isToss = useDeviceInfoStore(useShallow(_temp));
  const {
    saveLoginUrlData
  } = useLoginUrlData();
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("disableOutlink");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const disableOutlink = t0 === "true";
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("redirect");
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const redirect = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams.get("logout");
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const logout = t2 === "true";
  const {
    back
  } = useCustomRouter();
  useStoreMemberCode();
  let t3;
  let t4;
  if ($[6] !== isToss || $[7] !== logout || $[8] !== saveLoginUrlData) {
    t3 = () => {
      if (isToss && !logout) {
        sessionStorage.setItem(STORAGE_KEY.IS_LOGIN_PROGRESS, "true");
        sessionStorage.setItem(STORAGE_KEY.SIGNUP_METHOD, "\uD1A0\uC2A4");
        sessionStorage.setItem(STORAGE_KEY.SIGNUP_TYPE, "\uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80");
        saveLoginUrlData();
        location.href = createOAuthUrl({
          type: "toss",
          domain: window.location.origin,
          redirectPath: ROUTES.AUTH.pathname,
          clientId: ENV.NEXT_PUBLIC_TOSS_CLIENT_ID,
          scope: "user_ci user_birthday user_nationality user_name user_phone user_gender user_email"
        });
      }
    };
    t4 = [saveLoginUrlData, isToss, logout];
    $[6] = isToss;
    $[7] = logout;
    $[8] = saveLoginUrlData;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== back || $[12] !== disableOutlink || $[13] !== isDesktop || $[14] !== isToss || $[15] !== logout || $[16] !== redirect) {
    t5 = isToss && !logout ? <LoadingPageTemplate unmountedPlaceholder={true} /> : <NarrowContentContainer><article className={cn("relative flex flex-col", isDesktop ? "flex-1" : "h-dvh")}><nav className="absolute right-0 top-0 z-20 px-20 pt-16"><Button className={cn("flex size-fit border-none p-0", {
            "invisible cursor-default": disableOutlink,
            hidden: isDesktop
          })} disabled={disableOutlink} theme="primary-text" onClick={() => back()}><SvgDelete className="size-20" /></Button></nav>{isDesktop ? <div className="flex flex-1 flex-col items-center justify-center gap-40"><div className="flex flex-col items-center gap-12 text-center"><h1 className="whitespace-pre-line font-700 typo-h3">{"\uC544\uC9C1 \uBABB \uBC1B\uC740 \uD61C\uD0DD\uC774\n\uAE30\uB2E4\uB9AC\uACE0 \uC788\uC5B4\uC694"}</h1><p className="font-500 text-Gray-700 typo-body2">정책 혜택부터 답례품까지, 하나의 계정으로</p></div><SocialLoginSection isDesktop={isDesktop} /></div> : <div className="flex flex-1 flex-col items-center justify-center gap-112 px-20"><SvgLogo className="h-40 w-118" /><div className="flex w-full flex-col gap-40"><div className="flex flex-col items-center gap-12 text-center"><h1 className="whitespace-pre-line font-700 typo-h5">{"\uC544\uC9C1 \uBABB \uBC1B\uC740 \uD61C\uD0DD\uC774\n\uAE30\uB2E4\uB9AC\uACE0 \uC788\uC5B4\uC694"}</h1><p className="font-500 text-Gray-700 typo-body4">정책 혜택부터 답례품까지, 하나의 계정으로</p></div><SocialLoginSection isDesktop={isDesktop} /></div></div>}{redirect === ROUTES.MY_RESIGN_MEMBER.pathname ? <Portal renderTo={getMainWrapperElement}><ResignModal /></Portal> : null}</article></NarrowContentContainer>;
    $[11] = back;
    $[12] = disableOutlink;
    $[13] = isDesktop;
    $[14] = isToss;
    $[15] = logout;
    $[16] = redirect;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default LoginTemplate;
function _temp(state) {
  return state.subDomain === SUB_DOMAIN.TOSS;
}